var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "mt-4" },
    [_c("task-progress", { attrs: { task: _vm.task } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }